import { getValue } from "@utils/lodash";
import LegalDetailsSvgComponent from "../../../../assets/svg-components/task-details/legal-details";
import ComplianceDetailsSvgComponent from "../../../../assets/svg-components/task-details/compliance-details";
import ImpactAssessmentSvgComponent from "../../../../assets/svg-components/task-details/impact-assessment";
import * as React from "react";
import { useState } from "react";

// import { UncontrolledAccordion } from "reactstrap";
import {
  UncontrolledAccordion,
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from "reactstrap";
import TaskDetailsSvgComponent from "../../../../assets/svg-components/task-details/task-details-icon";
import SubmenuArrowDownSvgComponent from "../../../../assets/svg-components/left-menu/submenu-arrow-down";
import { handleDownloadOnClick } from "@_common/downloadfile";
import { formatSmallString } from "@_common/format-text";
import DownloadNoCircleSvgComponent from "../../../../assets/svg-components/download-nocircle";

interface IVendorComplianceTaskDetailsTasksProps {
  data: object;
}

const VendorComplianceTaskDetailsTasks: React.FunctionComponent<
  IVendorComplianceTaskDetailsTasksProps
> = (props) => {
  const { data } = props;

  // Show More Content for Compliance Activity
  const complianceActivity = getValue(data, "compliance_activity", "");
  const maxCharCount = 100;
  const [showFullContent, setShowFullContent] = useState(false);

  const toggleContent = () => {
    setShowFullContent(!showFullContent);
  };

  const truncatedContent =
    complianceActivity.length > maxCharCount
      ? complianceActivity.substring(0, maxCharCount) + "..."
      : complianceActivity;

  return (
    <div className="map-vendor__search map-vendor__search--task-details pe-3">
      {/* <h4 className="map-vendor__task-title">Task Details</h4> */}
      <div className="d-flex align-items-center master-details-header">
        <TaskDetailsSvgComponent />
        <h4 className="master-details-title">Task Details</h4>
      </div>
      {/* Accordian  */}
      <UncontrolledAccordion
        open="1"
        defaultOpen="1"
        className="task-details-accordian-wrapper"
      >
        {getValue(data, `task_id`, "") ||
        getValue(data, `checkpoint.checkpoint_id`, "") ||
        getValue(data, `checkpoint.country.name`, "") ||
        getValue(data, `checkpoint.state.name`, "") ||
        getValue(data, `checkpoint.category_of_law.text`, "") ||
        getValue(data, `checkpoint.legislation.legislation_name`, "") ||
        getValue(data, `checkpoint.legislation_rule.rule_name`, "") ||
        getValue(data, `checkpoint.reference`, "") ||
        getValue(data, `checkpoint.who`, "") ||
        getValue(data, `checkpoint.when`, "") ||
        getValue(data, `checkpoint.compliance_activity`, "") ? (
          <AccordionItem>
            <AccordionHeader targetId="1">
              <div className="accordian-header-wrap d-flex align-items-center">
                <LegalDetailsSvgComponent />
                <div className="accordion-header-title">Legal Details</div>
              </div>
            </AccordionHeader>
            <AccordionBody accordionId="1">
              <div className="task-details-accordian-body-wrapper">
                {/* d-flex align-items-start flex-wrap  */}
                <div className="td-accordian-information-wrap">
                  {getValue(data, `task_id`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/checkpoint-id.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Task ID</p>
                          <h6 style={{ wordBreak: "break-word" }}>
                            {getValue(data, `task_id`, "")}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.checkpoint_id`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/checkpoint-id.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Checkpoint ID</p>
                          <h6 style={{ wordBreak: "break-word" }}>
                            {getValue(data, `checkpoint.checkpoint_id`, "")}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.country.name`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/country.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Country</p>
                          <h6>
                            {getValue(data, `checkpoint.country.name`, "")}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.state.name`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/country.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>State</p>
                          <h6>{getValue(data, `checkpoint.state.name`, "")}</h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.category_of_law.text`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/category-of-law.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Category Of Law</p>
                          <h6>
                            {getValue(
                              data,
                              `checkpoint.category_of_law.text`,
                              ""
                            )}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(
                    data,
                    `checkpoint.legislation.legislation_name`,
                    ""
                  ) && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/legislation.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Legislation</p>
                          <h6>
                            {getValue(
                              data,
                              `checkpoint.legislation.legislation_name`,
                              ""
                            )}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(
                    data,
                    `checkpoint.legislation_rule.rule_name`,
                    ""
                  ) && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/rule.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Rule</p>
                          <h6>
                            {getValue(
                              data,
                              `checkpoint.legislation_rule.rule_name`,
                              ""
                            )}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.reference`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/reference.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Reference</p>
                          <h6>{getValue(data, `checkpoint.reference`, "")}</h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.who`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/who.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Who</p>
                          <h6>{getValue(data, `checkpoint.who`, "")}</h6>
                        </div>
                      </div>
                    </div>
                  )}
                  {getValue(data, `checkpoint.when`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/when.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>When</p>
                          <h6>{getValue(data, `checkpoint.when`, "")}</h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.compliance_activity`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/compliance-activity.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Compliance Activity</p>
                          <h6>
                            {getValue(
                              data,
                              `checkpoint.compliance_activity`,
                              ""
                            )}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `compliance_activity`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/compliance-activity.svg"
                          className="image-fluid td-icon-holder"
                          alt="Compliance Activity Icon"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Compliance Activity</p>
                          <h6>
                            {showFullContent
                              ? complianceActivity
                              : truncatedContent}
                            {complianceActivity.length > maxCharCount && (
                              <span
                                onClick={toggleContent}
                                style={{ cursor: "pointer" }}
                              >
                                {showFullContent ? (
                                  <span
                                    style={{ color: "#276ef1" }}
                                    className="viewLess"
                                  >
                                    &nbsp; View less{" "}
                                    <span
                                      style={{
                                        transform: "rotate(180deg)",
                                        display: "inline-block",
                                      }}
                                    >
                                      {" "}
                                      <SubmenuArrowDownSvgComponent color="#276ef1" />{" "}
                                    </span>
                                  </span>
                                ) : (
                                  <span
                                    style={{ color: "#276ef1" }}
                                    className="viewMore"
                                  >
                                    &nbsp; View more{" "}
                                    <SubmenuArrowDownSvgComponent color="#276ef1" />
                                  </span>
                                )}
                              </span>
                            )}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </AccordionBody>
          </AccordionItem>
        ) : null}

        {/* Compliance Details Accordion */}
        {getValue(data, `checkpoint.procedure`, "") ||
        getValue(data, `checkpoint.more_information`, "") ||
        getValue(data, `checkpoint.prohibitive.text`, "") ||
        getValue(data, `checkpoint.frequency.text`, "") ||
        getValue(data, `checkpoint.form_no`, "") ||
        getValue(data, `checkpoint.task_type.text`, "") ||
        getValue(data, `checkpoint.level.text`, "") ||
        getValue(data, `checkpoint.exemption_criteria`, "") ||
        getValue(data, `checkpoint.events.text`, "") ||
        getValue(data, `checkpoint.sub_events_id`, "") ||
        getValue(data, `checkpoint.compliance_type.text`, "") ? (
          <AccordionItem>
            <AccordionHeader targetId="2">
              <div className="accordian-header-wrap d-flex align-items-center">
                <ComplianceDetailsSvgComponent />
                <div className="accordion-header-title">Compliance Details</div>
              </div>
            </AccordionHeader>
            <AccordionBody accordionId="2">
              <div className="task-details-accordian-body-wrapper">
                <div className="td-accordian-information-wrap">
                  {getValue(data, `checkpoint.procedure`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/procedure.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Procedure</p>
                          <h6>{getValue(data, `checkpoint.procedure`, "")}</h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.more_information`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/more-info.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>More Information</p>
                          <h6>
                            {getValue(data, `checkpoint.more_information`, "")}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.prohibitive.text`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/prohibitive.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Prohibitive/Prescriptive</p>
                          <h6>
                            {getValue(data, `checkpoint.prohibitive.text`, "")}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.frequency.text`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/frequency.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Frequency</p>
                          <h6>
                            {getValue(data, `checkpoint.frequency.text`, "")}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.form_no`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/form-no.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Form No</p>
                          <h6>{getValue(data, `checkpoint.form_no`, "")}</h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* {getValue(data, `checkpoint.task_type.text`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/task-type.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Task Type</p>
                          <h6>
                            {getValue(data, `checkpoint.task_type.text`, "")}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )} */}

                  {getValue(data, `checkpoint.compliance_type.text`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/checkpoint-id.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Compliance Type </p>
                          <h6>
                            {getValue(
                              data,
                              `checkpoint.compliance_type.text`,
                              ""
                            )}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.level.text`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/level.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Level</p>
                          <h6>{getValue(data, `checkpoint.level.text`, "")}</h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.exemption_criteria`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/excemption-criteria.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Exemption Criteria</p>
                          <h6>
                            {getValue(
                              data,
                              `checkpoint.exemption_criteria`,
                              ""
                            )}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.events.text`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/events.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Events</p>
                          <h6>
                            {getValue(data, `checkpoint.events.text`, "")}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.sub_events_id`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/events.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Sub Events ID</p>
                          <h6>
                            {getValue(data, `checkpoint.sub_events_id`, "")}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </AccordionBody>
          </AccordionItem>
        ) : null}

        {getValue(data, `checkpoint.impact`, "") ||
        getValue(data, `checkpoint.unit`, "") ||
        getValue(data, `checkpoint.impact_on_organization.text`, "") ||
        getValue(data, `checkpoint.inter_linkage`, "") ||
        getValue(data, `checkpoint.linked_task_id`, "") ||
        getValue(data, `checkpoint.document_type.text`, "") ||
        getValue(data, `checkpoint.implication`, "") ||
        getValue(data, `checkpoint.imprisonment_duration`, "") ||
        getValue(data, `checkpoint.imprisonment_applies.text`, "") ||
        getValue(data, `checkpoint.fine_amount`, "") ||
        getValue(data, `checkpoint.subsequent_amount_per_day`, "") ? (
          <AccordionItem>
            <AccordionHeader targetId="3">
              <div className="accordian-header-wrap d-flex align-items-center">
                <ImpactAssessmentSvgComponent />
                <div className="accordion-header-title">Impact Assessment</div>
              </div>
            </AccordionHeader>
            <AccordionBody accordionId="3">
              <div className="task-details-accordian-body-wrapper">
                <div className="td-accordian-information-wrap">
                  {getValue(data, `checkpoint.impact`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/impact.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Impact</p>
                          <h6>{getValue(data, `checkpoint.impact`, "")}</h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.unit`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/impact-unit.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Impact on Unit</p>
                          <h6>{getValue(data, `checkpoint.unit`, "")}</h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(
                    data,
                    `checkpoint.impact_on_organization.text`,
                    ""
                  ) && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/impact-org.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Impact on Organization</p>
                          <h6>
                            {getValue(
                              data,
                              `checkpoint.impact_on_organization.text`,
                              ""
                            )}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}
                  {getValue(data, `checkpoint.implication`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/implication.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Implication</p>
                          <h6 style={{ wordBreak: "break-word" }}>
                            {getValue(data, `checkpoint.implication`, "")}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.imprisonment_duration`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/imprisonment-duration.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Imprisonment Duration</p>
                          <h6>
                            {getValue(
                              data,
                              `checkpoint.imprisonment_duration`,
                              ""
                            )}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(
                    data,
                    `checkpoint.imprisonment_applies.text`,
                    ""
                  ) && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/imprisonment-applies.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Imprisonment Applies to</p>
                          <h6>
                            {getValue(
                              data,
                              `checkpoint.imprisonment_applies.text`,
                              ""
                            )}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.fine_amount`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/fine.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Fine Amount (INR)</p>
                          <h6>
                            {getValue(data, `checkpoint.fine_amount`, "")}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(
                    data,
                    `checkpoint.subsequent_amount_per_day`,
                    ""
                  ) && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/fine.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Subsequent Amount per Day (INR)</p>
                          <h6>
                            {getValue(
                              data,
                              `checkpoint.subsequent_amount_per_day`,
                              ""
                            )}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}
                  {getValue(data, `checkpoint.inter_linkage`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/interlinkage.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Interlinkage</p>
                          <h6>
                            {getValue(data, `checkpoint.inter_linkage`, "")}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.linked_task_id`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/checkpoint-id.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Linked task id</p>
                          <h6>
                            {getValue(data, `checkpoint.linked_task_id`, "")}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.document_type.text`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/doc-type.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Document Type</p>
                          <h6>
                            {getValue(
                              data,
                              `checkpoint.document_type.text`,
                              ""
                            )}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </AccordionBody>
          </AccordionItem>
        ) : null}
      </UncontrolledAccordion>

      {/* {getValue(data, `documents`, []).length > 0 && (
        <>
          <div className="download-checkpoint">
            <h4 className="master-details-title">Reference Document</h4>
          </div>
          {getValue(data, `documents`, []).map((document: any) => (
            <>
              <div
                className="attach-files-wrapper__files cursor-pointer d-flex justify-content-between mt-2"
                key={document.id}
              >
                <p
                  key={document.id}
                  style={{
                    fontSize: "12px",
                    marginTop: "0px",
                    textAlign: "center",
                  }}
                  onClick={() =>
                    handleDownloadOnClick(document.url, document.name)
                  }
                >
                  {formatSmallString(document.name)}
                </p>

                <DownloadNoCircleSvgComponent size={18} />
              </div>
            </>
          ))}
        </>
      )} */}

      {/* {getValue(data, `lexcare_task_id`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/svg" className="image-fluid" />
          <div className="mx-2">
            <p>Checkpoint ID</p>
            <h6>{getValue(data, `lexcare_task_id`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `ttrn_id`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/svg" className="image-fluid" />
          <div className="mx-2">
            <p>Checkpoint ID</p>
            <h6>{getValue(data, `ttrn_id`, "")}</h6>
          </div>
        </div>
      )}

      {getValue(data, `country.name`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/svg" className="image-fluid" />
          <div className="mx-2">
            <p>Country</p>
            <h6>{getValue(data, `country.name`, "")}</h6>
          </div>
        </div>
      )}

      {getValue(data, `state`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/svg" className="image-fluid" />
          <div className="mx-2">
            <p>State</p>
            <h6>{getValue(data, `state`, "")}</h6>
          </div>
        </div>
      )}

      {getValue(data, `category.text`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/svg" className="image-fluid" />
          <div className="mx-2">
            <p>category</p>
            <h6>{getValue(data, `category.text`, "")}</h6>
          </div>
        </div>
      )}

      {getValue(data, `period.text`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/svg" className="image-fluid" />
          <div className="mx-2">
            <p>period</p>
            <h6>{getValue(data, `period.text`, "")}</h6>
          </div>
        </div>
      )}

      {getValue(data, `control_frequency.text`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/svg" className="image-fluid" />
          <div className="mx-2">
            <p>Control Frequency</p>
            <h6>{getValue(data, `control_frequency.text`, "")}</h6>
          </div>
        </div>
      )}

      {getValue(data, `overall_risk_rating`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/svg" className="image-fluid" />
          <div className="mx-2">
            <p>Overall Risk Rating</p>
            <h6>{getValue(data, `overall_risk_rating`, "")}</h6>
          </div>
        </div>
      )}

      {getValue(data, `risk`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/svg" className="image-fluid" />
          <div className="mx-2">
            <p>Risk</p>
            <h6>{getValue(data, `risk`, "")}</h6>
          </div>
        </div>
      )}

      {getValue(data, `process_name`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/svg" className="image-fluid" />
          <div className="mx-2">
            <p>Process Name</p>
            <h6>{getValue(data, `process_name`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `regulation`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/svg" className="image-fluid" />
          <div className="mx-2">
            <p>Regulation</p>
            <h6>{getValue(data, `regulation`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.compliance_activity`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/svg" className="image-fluid" />
          <div className="mx-2">
            <p>Activity</p>
            <h6>{getValue(data, `checkpoint.compliance_activity`, "")}</h6>
          </div>
        </div>
      )}

      {getValue(data, `checkpoint.frequency.text`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/task-details-img2.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Frequency</p>
            <h6>{getValue(data, `checkpoint.frequency.text`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.category_of_law.text`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/task-details-img3.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Category Of Law</p>
            <h6>{getValue(data, `checkpoint.category_of_law.text`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.legislation.legislation_name`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/task-details-img4.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Legislation</p>
            <h6>
              {getValue(data, `checkpoint.legislation.legislation_name`, "")}
            </h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.legislation_rule.rule_name`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/task-details-img5.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Rule</p>
            <h6>
              {getValue(data, `checkpoint.legislation_rule.rule_name`, "")}
            </h6>
          </div>
        </div>
      )}
      {getValue(data, `compliance_activity`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/task-details-img6.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Compliance Activity</p>
            <h6>{getValue(data, `compliance_activity`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `location.location_name`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/task-details-img7.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Location</p>
            <h6>{getValue(data, `location.location_name`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `license_type.text`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/task-details-img7.svg" className="image-fluid" />
          <div className="mx-2">
            <p>License Type</p>
            <h6>{getValue(data, `license_type.text`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.who`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/who.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Who</p>
            <h6>{getValue(data, `checkpoint.who`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.when`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/when.svg" className="image-fluid" />
          <div className="mx-2">
            <p>When</p>
            <h6>{getValue(data, `checkpoint.when`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.reference`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/reference.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Reference</p>
            <h6>{getValue(data, `checkpoint.reference`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.procedure`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/procedure.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Procedure</p>
            <h6>{getValue(data, `checkpoint.procedure`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.more_information`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/more-information.svg" className="image-fluid" />
          <div className="mx-2">
            <p>More Information</p>
            <h6>{getValue(data, `checkpoint.more_information`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.prohibitive.text`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/prohebitive.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Prohibitive/Prescriptive</p>
            <h6>{getValue(data, `checkpoint.prohibitive.text`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.task_type.text`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/type-of-task.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Type of Task</p>
            <h6>{getValue(data, `checkpoint.task_type.text`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.level.text`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/level.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Level</p>
            <h6>{getValue(data, `checkpoint.level.text`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.form_no`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/form-no.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Form No</p>
            <h6>{getValue(data, `checkpoint.form_no`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.document_type.text`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/document-type.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Document Type</p>
            <h6>{getValue(data, `checkpoint.document_type.text`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.compliance_type.text`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/compliance-type.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Compliance Type </p>
            <h6>{getValue(data, `checkpoint.compliance_type.text`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.impact`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/impact.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Impact</p>
            <h6>{getValue(data, `checkpoint.impact`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.impact_on_organization.text`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/impact-organization.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Impact on Organization</p>
            <h6>
              {getValue(data, `checkpoint.impact_on_organization.text`, "")}
            </h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.unit`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/impact-organization.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Impact on Unit</p>
            <h6>{getValue(data, `checkpoint.unit`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.imprisonment_applies.text`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/imprisement-applies.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Imprisonment Applies to</p>
            <h6>
              {getValue(data, `checkpoint.imprisonment_applies.text`, "")}
            </h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.implication`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/implication.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Implication</p>
            <h6>{getValue(data, `checkpoint.implication`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.imprisonment_duration`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/imprisement-duration.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Imprisonment Duration</p>
            <h6>{getValue(data, `checkpoint.imprisonment_duration`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.fine_amount`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/fine-amount.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Fine Amount (INR)</p>
            <h6>{getValue(data, `checkpoint.fine_amount`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.subsequent_amount_per_day`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/sub-sequent.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Subsequent Amount per Day (INR)</p>
            <h6>
              {getValue(data, `checkpoint.subsequent_amount_per_day`, "")}
            </h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.events.text`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/events.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Events</p>
            <h6>{getValue(data, `checkpoint.events.text`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.exemption_criteria`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/exemption.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Exemption Criteria</p>
            <h6>{getValue(data, `checkpoint.exemption_criteria`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.inter_linkage`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/inter-linkage.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Inter Linkage</p>
            <h6>{getValue(data, `checkpoint.inter_linkage`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.linked_task_id`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/link-task.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Linked Task ID</p>
            <h6>{getValue(data, `checkpoint.linked_task_id`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.sub_events_id`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/sub-event.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Sub Events ID</p>
            <h6>{getValue(data, `checkpoint.sub_events_id`, "")}</h6>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default VendorComplianceTaskDetailsTasks;
